import * as Highcharts from 'highcharts';
import {ChartTemplateService} from '../../../charts-templates/chart-template.service'; // NOSONAR
import {SeriesAbsolutPerc} from 'shared/dtos/cockpit/charts/seriesAbsolutPerc'; // NOSONAR
import {
  ABSOLUT,
  ANTEIL,
  GESTAPELT,
  UNGESTAPELT
} from 'shared/EnumsConstants/card-charts-translate-keys.enum'; // NOSONAR
import {Component, Inject, Input, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {WINDOW} from '@oblique/oblique';

@Component({
  selector: 'app-chart-anzahl-anteil-mitarbeitende',
  templateUrl: './chart-anzahl-anteil-mitarbeitende.component.html',
  styleUrl: '../../../../cockpit-shared/card/card.component.scss',
  providers: [ChartTemplateService],
  standalone: false
})
export class ChartAnzahlAnteilMitarbeitendeComponent implements OnInit {
  chart: any;
  isAbsolut = true;
  stacked = false;
  series: SeriesAbsolutPerc;
  crtSeries: string;
  gestapelt: string = GESTAPELT;
  ungestapelt: string = UNGESTAPELT;
  absolut: string = ABSOLUT;
  anteil: string = ANTEIL;

  constructor(
    @Inject(ChartTemplateService)
    private readonly chartTemplateService: ChartTemplateService,
    private readonly translateService: TranslateService,
    @Inject(WINDOW) private readonly window
  ) {}

  @Input() set seriesAnzahlAnteilMitarbeitende(series: SeriesAbsolutPerc) {
    if (series) {
      this.series = series;
      this.initialize(this.series);
    }
  }

  ngOnInit(): void {
    this.translateService.onLangChange.subscribe(() => {
      const svgContainer = document.getElementById(
        'svgContainerChartAnzahlAnteilMitarbeitende'
      );
      if (svgContainer) {
        this.initialize(this.series);
      }
    });
  }

  initialize(series: SeriesAbsolutPerc) {
    this.chartTemplateService.chartname = 'anzahlAnteilMitarbeitende';
    this.initHighCharts(JSON.parse(series.seriesAbsolute));
    this.toggleDisplayChartSerie(this.chart);
  }

  selectionAbsolutAnteilChanged(item) {
    if (item.value === ABSOLUT) {
      this.isAbsolut = true;
    } else {
      this.isAbsolut = false;
    }
    this.toggleDisplayChartSerie(this.chart);
  }

  selectionGestapeltUngestepeltChanged(item) {
    if (item.value === GESTAPELT) {
      this.stacked = true;
    } else {
      this.stacked = false;
    }
    this.toggleDisplayChartSerie(this.chart);
  }

  private toggleDisplayChartSerie(chart: Highcharts.Chart) {
    if (!this.chart.hasLoaded) {
      this.intitializeChart();
      chart = this.chart;
    }

    if (this.isAbsolut) {
      this.crtSeries = this.series.seriesAbsolute;
    } else {
      this.crtSeries = this.series.seriesPercent;
    }

    if (!chart.series) {
      this.initHighCharts(JSON.parse(this.crtSeries));
    }

    this.setDisplayInfoStackedCharts(chart);
  }

  private setDisplayInfoStackedCharts(chart: Highcharts.Chart) {
    let plotOptions = {};
    const title = this.isAbsolut
      ? this.translateService.instant(
          'i18n.cockpit.card.chart.personalbestand.vae.anzahlMitarbeitende'
        )
      : this.translateService.instant(
          'i18n.cockpit.card.chart.personalbestand.vae.anteillMitarbeitende'
        );

    const pointFormat = this.isAbsolut
      ? '<span style="color:{series.color}">{series.name}</span>: <span class="strong">{point.y}</span><br/>'
      : '<span style="color:{series.color}">{series.name}</span>: <span class="strong"></span>{point.y}</span> %<br/>';

    const valueDecimals = this.isAbsolut ? 0 : 2;
    const tooltip = {
      pointFormat,
      valueDecimals
    };

    const max = this.isAbsolut ? null : 100;
    const labels = this.isAbsolut ? null : '{value}%';
    const ticks = this.isAbsolut ? null : 20;

    const yAxis = {
      min: 0,
      max,
      title: {text: ''},
      labels: {format: labels},
      tickInterval: ticks
    };

    const series = this.crtSeries
      ? JSON.parse(this.chartTemplateService.translateChart(this.crtSeries))
      : chart.options.series;

    if (this.stacked) {
      plotOptions = {
        plotOptions: {
          series: {stacking: 'normal'}
        },
        title: {
          text: title,
          style: {color: '#333333', fontSize: '16px'}
        },
        series,
        tooltip,
        yAxis,
        responsive: this.chartTemplateService.getResponsive()
      };
    } else {
      plotOptions = {
        plotOptions: {
          series: {stacking: ''}
        },
        title: {
          text: title,
          style: {color: '#333333', fontSize: '16px'}
        },
        series,
        tooltip,
        yAxis,
        responsive: this.chartTemplateService.getResponsive()
      };
    }
    chart.update(plotOptions, true);
    this.window.dispatchEvent(new Event('resize'));
    chart.reflow();
  }

  private initHighCharts(series: any) {
    const xAxis = {
      categories: [
        this.translateService.instant(
          'i18n.cockpit.card.chart.personalbestand.ma-imStundenlohn'
        ),
        this.translateService.instant(
          'i18n.cockpit.card.chart.personalbestand.ma-imMonatslohn'
        ),
        this.translateService.instant(
          'i18n.cockpit.card.chart.personalbestand.ma-gesamt'
        )
      ]
    };
    const chartTitle = {
      text: this.translateService.instant(
        'i18n.cockpit.card.chart.personalbestand.vae.anzahlMitarbeitende'
      ),
      style: {color: '#333333', fontSize: '16px'}
    };
    const yAxis = {
      labelsFormat: null,
      min: 0,
      max: null,
      tickInterval: 20,
      titleText: ''
    };
    const legend = {reversed: true};
    const tooltip = {
      pointFormat:
        '<span style="color:{series.color}">{series.name}</span>: <span style="font-weight:bold;">{point.y}</span><br/>',
      valueDecimals: 0
    };

    this.chartTemplateService.initializeChartValues(
      series,
      chartTitle,
      xAxis,
      yAxis,
      legend,
      this.stacked ? 'normal' : '',
      tooltip
    );

    this.intitializeChart();
  }

  private intitializeChart() {
    Highcharts.chart(
      'svgContainerChartAnzahlAnteilMitarbeitende',
      this.chartTemplateService.json,
      thechart => {
        this.callBackFuncToNormalizeBarChart(thechart);

        // Observer pour détecter les changements de taille du conteneur
        const resizeObserver = new ResizeObserver(() => {
          if (this.chart) {
            this.chart.reflow();
          }
        });
        resizeObserver.observe(
          document.getElementById('svgContainerChartAnzahlAnteilMitarbeitende')
        );
      }
    );
  }

  private callBackFuncToNormalizeBarChart(thechart: any) {
    this.chart = thechart;
    thechart.reflow();
  }
}
